<template>
    <div>
        <div class="d-flex flex-justify-center mb-3" style="background: #f2efe9">
            <picture>
                <source
                    :srcset="$scope.CDN_IMAGES + '/' + filteredModel.size_guide_banner_mobile"
                    media="(max-width: 576px)"
                />
                <source
                    :srcset="$scope.CDN_IMAGES + '/' + filteredModel.size_guide_banner_tablet"
                    media="(max-width: 768px)"
                />
                <img
                    :src="$scope.CDN_IMAGES + '/' + filteredModel.size_guide_banner_desktop"
                    alt="Guia de Tamanhos"
                    class="img-responsive"
                />
            </picture>
        </div>
        <div class="content">
            <div class="mb-5 mt-5">
                <h1>{{ filteredModel.size_guide_title }}</h1>
                <p>
                    {{ filteredModel.size_guide_text }}
                </p>
            </div>
        </div>
        <div class="size-guide-filters-box mb-4">
            <div class="size-guide-filters-container content">
                <div class="size-guide-filters">
                    <div class="d-flex flex-align-center">
                        <select
                            v-model="selectedSize"
                            :class="{ active: selectedSize }"
                            style="height: 2.5rem"
                        >
                            <option :key="0" label="Tamanho" :value="null" />
                            <option
                                v-for="(size, index) in filteredModel.sizes"
                                :key="index"
                                :label="size.name"
                                :value="index"
                            />
                        </select>
                        <i class="icon-cr icon-chevron-right accent" />
                    </div>
                    <div class="d-flex flex-align-center">
                        <select
                            v-model="selectedModel"
                            :class="{ active: selectedModel }"
                            style="height: 2.5rem"
                        >
                            <option :key="0" label="Modelos" :value="null"></option>
                            <option
                                v-for="model in modelosSortedByName"
                                :key="model.id"
                                :label="model.nome"
                                :value="model.id"
                            />
                        </select>
                        <i class="icon-cr icon-chevron-right accent" />
                    </div>
                </div>
                <div class="d-flex">
                    <button
                        class="btn-light text-uppercase cursor-pointer"
                        @click="goBack()"
                        style="height: 2.5rem"
                    >
                        Selecionar outro produto
                    </button>
                </div>
            </div>
        </div>
        <div class="content">
            <SizeGuideModelV2
                :class="{ busy: loading }"
                class="mb-5"
                v-for="model in filteredModelos"
                :key="model.id"
                :model="model"
                :product-type-id="filteredModel.product_type_id"
                :selected-size="parseInt(selectedSize)"
                :sizes="filteredModel.sizes"
                @show-zoom="showZoom"
            />

            <SizeGuideZoomV2
                v-if="currentZoomModel"
                :current-model="currentZoomModel"
                :current-size-id="currentSizeId"
                :product-model="filteredModel"
                :sizes="filteredModel.sizes"
                @hide="hideZoom"
                @go-next="goNext"
                @go-previous="goPrevious"
                @type-changed="currentTypeId = $event"
            />
        </div>
    </div>
</template>

<script>
    import SizeGuideModelV2 from './SizeGuideModelV2.vue';
    import SizeGuideZoomV2 from './SizeGuideZoomV2.vue';
    import SelectField from '@bit/chicorei.chicomponents.input.select-field';
    import CatalogFilterGroupDesktop from '../catalog/CatalogFilterGroupDesktop.vue';
    import CatalogFilterGroupOption from '../catalog/CatalogFilterGroupOption.vue';

    export default {
        name: 'SizeGuideDetails',
        components: {
            CatalogFilterGroupOption,
            CatalogFilterGroupDesktop,
            SelectField,
            SizeGuideZoomV2,
            SizeGuideModelV2,
        },

        props: {
            modelsData: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                currentZoomModel: null,
                currentImageIndex: null,
                currentSizeId: null,
                currentTypeId: 1,
                selectedModel: null,
                selectedSize: null,
                loading: false,
            };
        },

        computed: {
            filteredModel() {
                const url_id = parseInt(this.$route.params.modelName.match(/\d+/g).join(''));
                return this.modelsData.find((el) => el.id === url_id);
            },

            filteredModelos() {
                return this.filteredModel.models
                    .filter((m) => !this.selectedModel || m.id === this.selectedModel)
                    .sort((a, b) => (a.altura > b.altura ? 1 : -1));
            },

            modelosSortedByName() {
                return this.filteredModel.models.sort((a, b) => (a.nome > b.nome ? 1 : -1));
            },

            sortedAvailableSizes() {
                if (!this.currentZoomModel) {
                    return null;
                }

                let availableSizes = {};
                this.currentZoomModel.images.forEach((i) => {
                    availableSizes[i.size_id] = true;
                });

                return Object.keys(availableSizes)
                    .filter((s) => s != 0)
                    .sort((a, b) => {
                        return this.filteredModel.sizes[parseInt(a)].order >
                            this.filteredModel.sizes[parseInt(b)].order
                            ? 1
                            : -1;
                    });
            },
        },

        methods: {
            showZoom(model, sizeId) {
                this.currentZoomModel = model;
                this.currentSizeId = sizeId;
            },

            hideZoom() {
                this.currentZoomModel = null;
                this.currentSizeId = null;
            },

            goNext() {
                const nextIndex =
                    this.sortedAvailableSizes.findIndex((size) => size == this.currentSizeId) + 1;

                this.currentSizeId = parseInt(
                    this.sortedAvailableSizes[nextIndex % this.sortedAvailableSizes.length]
                );
            },

            goPrevious() {
                let previousIndex =
                    this.sortedAvailableSizes.findIndex((size) => size == this.currentSizeId) - 1;

                if (previousIndex < 0) {
                    previousIndex = this.sortedAvailableSizes.length - 1;
                }

                this.currentSizeId = parseInt(this.sortedAvailableSizes[previousIndex]);
            },

            goBack() {
                this.$router.push({
                    name: 'home',
                });
            },
        },
    };
</script>